module.exports = __webpack_public_path__ + "img/ppt-2.5dace381.png";